"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.aggregateMergedQuestions = exports.GenericProduct = void 0;
const GenericAutreCgpRequestResource_1 = __importDefault(require("./GenericAutreCgpRequestResource"));
const GenericConnaissanceExperienceRequestResource_1 = __importDefault(require("./GenericConnaissanceExperienceRequestResource"));
const GenericFinanceDurableRequestResource_1 = __importDefault(require("./GenericFinanceDurableRequestResource"));
const GenericPatrimoineRequestResource_1 = __importDefault(require("./GenericPatrimoineRequestResource"));
const GenericTestAdequationRequestResource_1 = __importDefault(require("./GenericTestAdequationRequestResource"));
exports.GenericProduct = {
    payment_methods: {
        groups: [],
        validationClass: GenericPatrimoineRequestResource_1.default,
    },
    patrimoine_revenus: {
        groups: [],
        validationClass: GenericPatrimoineRequestResource_1.default,
    },
    connaissance_experience: {
        groups: [],
        validationClass: GenericConnaissanceExperienceRequestResource_1.default,
    },
    test_adequation: {
        groups: [],
        validationClass: GenericTestAdequationRequestResource_1.default,
    },
    finance_durable: {
        groups: [],
        validationClass: GenericFinanceDurableRequestResource_1.default,
    },
    autre_cgp: {
        groups: [],
        validationClass: GenericAutreCgpRequestResource_1.default,
    },
    files: {
        groups: [],
        validationClass: GenericPatrimoineRequestResource_1.default,
    },
};
function aggregateMergedQuestions(products) {
    const accumulator = {
        payment_methods: { groups: [], validationClass: exports.GenericProduct.payment_methods.validationClass },
        patrimoine_revenus: { groups: [], validationClass: exports.GenericProduct.patrimoine_revenus.validationClass },
        connaissance_experience: { groups: [], validationClass: exports.GenericProduct.connaissance_experience.validationClass },
        test_adequation: { groups: [], validationClass: exports.GenericProduct.test_adequation.validationClass },
        finance_durable: { groups: [], validationClass: exports.GenericProduct.finance_durable.validationClass },
        autre_cgp: { groups: [], validationClass: exports.GenericProduct.autre_cgp.validationClass },
        files: { groups: [], validationClass: exports.GenericProduct.files.validationClass },
    };
    const res = products.reduce((acc, curr) => {
        const keys = Object.keys(curr);
        keys.forEach((key) => {
            const combinedSet = new Set([...(acc[key].groups || []), ...(curr[key].groups || [])]);
            acc[key].groups.splice(0);
            acc[key].groups.push(...Array.from(combinedSet));
        });
        return acc;
    }, accumulator);
    return res;
}
exports.aggregateMergedQuestions = aggregateMergedQuestions;
